import React from "react";
import "./StoreBadge.css";

export interface StoreBadgeProps {
  icon: string;
  tagline: string;
  storeName: string;
  className?: string;
}

const StoreBadge: React.FC<StoreBadgeProps> = ({
  icon,
  tagline,
  storeName,
  className = "",
}) => (
  <span className={`store-badge-item ${className}`.trim()}>
    <img src={icon} alt="badge-icon" className="store-badge-item__icon" />
    <span className="store-badge-item__text">
      <span className="store-badge-item__tagline">{tagline}</span>
      <span className="store-badge-item__store-name">{storeName}</span>
    </span>
  </span>
);

export default StoreBadge;
